export const videosPartA = [
  {
    id: "m1",
    title: "星际边界",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Lone%20astronaut%20standing%20before%20a%20giant%20glowing%20wormhole%20in%20deep%20space%20with%20distant%20nebula%20and%20scattered%20stars%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-m1&orientation=landscape",
    duration: "02:16:40",
    uploadedAt: "2024-09-18",
    year: "2024",
    region: "美国",
    type: "科幻",
    playCount: 1286000,
    rating: 9.1,
    uploader: "星河影业",
    description: "一名宇航员穿越虫洞寻找失联的母舰，在时间与记忆的裂缝中重新定义归途的意义。",
    tags: ["科幻", "太空", "冒险"],
  },
  {
    id: "m2",
    title: "长夜将尽",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20night%20city%20alley%20with%20a%20silhouetted%20detective%20under%20a%20single%20streetlamp%20and%20reflective%20wet%20pavement%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-m2&orientation=landscape",
    duration: "01:58:12",
    uploadedAt: "2024-08-30",
    year: "2024",
    region: "中国大陆",
    type: "悬疑",
    playCount: 964000,
    rating: 8.7,
    uploader: "暗夜工作室",
    description: "一桩尘封十年的旧案重新浮出水面，落魄警探在漫长的雨夜里追寻被掩埋的真相。",
    tags: ["悬疑", "犯罪", "推理"],
  },
  {
    id: "m3",
    title: "城市之光",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20European%20old%20town%20street%20at%20dusk%20with%20glowing%20windows%20and%20a%20lone%20figure%20walking%20home%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-m3&orientation=landscape",
    duration: "01:44:05",
    uploadedAt: "2023-11-22",
    year: "2023",
    region: "法国",
    type: "剧情",
    playCount: 712000,
    rating: 8.5,
    uploader: "塞纳河电影社",
    description: "一位街头艺人在巴黎的黄昏里遇见形形色色的人，用音乐点亮他人也照亮自己。",
    tags: ["剧情", "文艺", "音乐"],
  },
  {
    id: "m4",
    title: "绝地反击",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Explosive%20action%20scene%20in%20a%20ruined%20industrial%20warehouse%20with%20flying%20sparks%20and%20dramatic%20smoke%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-m4&orientation=landscape",
    duration: "02:04:33",
    uploadedAt: "2023-10-09",
    year: "2023",
    region: "美国",
    type: "动作",
    playCount: 1580000,
    rating: 8.9,
    uploader: "铁血制片厂",
    description: "退役特种兵为保护家人重出江湖，在一座废弃工厂里展开一场惊心动魄的绝地反击。",
    tags: ["动作", "枪战", "热血"],
  },
  {
    id: "m5",
    title: "夏日信箱",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Sunlit%20seaside%20post%20office%20in%20summer%20with%20a%20girl%20holding%20letters%20and%20floating%20sea%20breeze%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-m5&orientation=landscape",
    duration: "01:36:48",
    uploadedAt: "2024-07-14",
    year: "2024",
    region: "日本",
    type: "爱情",
    playCount: 843000,
    rating: 8.8,
    uploader: "风之海岸",
    description: "海边小镇的邮差小姐，用一封封迟到的信件，牵起两段跨越七年的温柔缘分。",
    tags: ["爱情", "治愈", "青春"],
  },
  {
    id: "m6",
    title: "深海回响",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Deep%20underwater%20scene%20with%20a%20submarine%20spotlight%20revealing%20a%20sunken%20ancient%20ruin%20and%20schools%20of%20fish%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-m6&orientation=landscape",
    duration: "01:52:20",
    uploadedAt: "2022-12-02",
    year: "2022",
    region: "英国",
    type: "冒险",
    playCount: 654000,
    rating: 8.4,
    uploader: "深蓝影像",
    description: "一支科考队潜入未知海沟，在幽暗的深海中发现了沉睡千年的远古遗迹。",
    tags: ["冒险", "科幻", "悬疑"],
  },
  {
    id: "m7",
    title: "无间迷局",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Neon%20lit%20Hong%20Kong%20harbor%20at%20night%20with%20two%20shadowy%20figures%20facing%20each%20other%20in%20the%20rain%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-m7&orientation=landscape",
    duration: "02:08:55",
    uploadedAt: "2024-06-21",
    year: "2024",
    region: "中国香港",
    type: "犯罪",
    playCount: 1120000,
    rating: 9.0,
    uploader: "九龙映画",
    description: "卧底与黑警在霓虹闪烁的码头展开最后的博弈，身份的迷雾中谁才是真正的赢家。",
    tags: ["犯罪", "警匪", "悬疑"],
  },
  {
    id: "m8",
    title: "追风少年",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Young%20runner%20sprinting%20on%20a%20sunset%20track%20with%20motion%20blur%20and%20flying%20dust%20particles%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-m8&orientation=landscape",
    duration: "01:48:16",
    uploadedAt: "2023-09-15",
    year: "2023",
    region: "韩国",
    type: "运动",
    playCount: 589000,
    rating: 8.6,
    uploader: "疾风传媒",
    description: "来自小城的短跑少年怀揣奥运梦想，在一次次跌倒与冲刺中证明自己的价值。",
    tags: ["运动", "励志", "青春"],
  },
  {
    id: "t1",
    title: "青云志传",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mountain%20sect%20with%20floating%20mist%20and%20a%20swordsman%20in%20flowing%20robes%20gazing%20at%20a%20golden%20sunrise%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-t1&orientation=landscape",
    duration: "全 40 集",
    uploadedAt: "2024-09-01",
    year: "2024",
    region: "中国大陆",
    type: "古装",
    playCount: 2340000,
    rating: 9.2,
    uploader: "云山影视",
    description: "少年背负灭门之仇拜入仙门，在仙魔纷争的乱世中书写一段荡气回肠的传奇。",
    tags: ["古装", "仙侠", "热血"],
  },
  {
    id: "t2",
    title: "都市夜归人",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20modern%20city%20skyscraper%20window%20at%20night%20with%20a%20tired%20commuter%20looking%20out%20over%20glowing%20traffic%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-t2&orientation=landscape",
    duration: "全 36 集",
    uploadedAt: "2024-08-18",
    year: "2024",
    region: "中国大陆",
    type: "都市",
    playCount: 1780000,
    rating: 8.9,
    uploader: "光影时代",
    description: "三个在深夜相遇的都市人，用各自的故事拼凑出这座巨大城市最真实的温度。",
    tags: ["都市", "情感", "现实"],
  },
  {
    id: "t3",
    title: "迷雾档案",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20small%20town%20police%20office%20at%20dawn%20with%20scattered%20case%20files%20and%20a%20glowing%20desk%20lamp%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-t3&orientation=landscape",
    duration: "全 24 集",
    uploadedAt: "2023-12-10",
    year: "2023",
    region: "美国",
    type: "悬疑",
    playCount: 1320000,
    rating: 9.0,
    uploader: "北境制片",
    description: "小镇警探在浓雾弥漫的清晨接到一通神秘来电，从此卷入一系列环环相扣的悬案。",
    tags: ["悬疑", "探案", "惊悚"],
  },
  {
    id: "t4",
    title: "权谋天下",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20candlelit%20medieval%20throne%20hall%20with%20nobles%20in%20dark%20robes%20and%20a%20raised%20royal%20banner%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-t4&orientation=landscape",
    duration: "全 30 集",
    uploadedAt: "2023-11-05",
    year: "2023",
    region: "英国",
    type: "历史",
    playCount: 1080000,
    rating: 8.8,
    uploader: "皇冠影业",
    description: "在血与火交织的王座之争中，各大家族为权力与信仰上演一场惊心动魄的博弈。",
    tags: ["历史", "权谋", "史诗"],
  },
  {
    id: "t5",
    title: "心跳急诊室",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20hospital%20emergency%20room%20at%20night%20with%20doctors%20in%20motion%20and%20glowing%20monitors%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-t5&orientation=landscape",
    duration: "全 32 集",
    uploadedAt: "2024-07-28",
    year: "2024",
    region: "韩国",
    type: "医疗",
    playCount: 1490000,
    rating: 9.1,
    uploader: "心跳工作室",
    description: "一群急诊科医生在生死时速中坚守初心，每一次心跳都是与时间赛跑的见证。",
    tags: ["医疗", "职业", "温情"],
  },
  {
    id: "t6",
    title: "我们的十年",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20school%20yard%20in%20golden%20afternoon%20light%20with%20a%20group%20of%20young%20friends%20laughing%20together%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-t6&orientation=landscape",
    duration: "全 28 集",
    uploadedAt: "2023-08-22",
    year: "2023",
    region: "中国大陆",
    type: "青春",
    playCount: 990000,
    rating: 8.7,
    uploader: "拾光传媒",
    description: "从懵懂校园到各自奔忙，五个好友用十年时间讲述关于成长、梦想与遗憾的故事。",
    tags: ["青春", "成长", "情感"],
  },
  {
    id: "t7",
    title: "霓虹街区",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Neon%20soaked%20Tokyo%20backstreet%20at%20night%20with%20a%20lone%20figure%20and%20reflective%20puddles%20everywhere%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-t7&orientation=landscape",
    duration: "全 20 集",
    uploadedAt: "2024-06-06",
    year: "2024",
    region: "日本",
    type: "犯罪",
    playCount: 870000,
    rating: 8.6,
    uploader: "新宿影社",
    description: "在霓虹永不熄灭的街区里，一名落寞侦探追查一桩牵动整座城市的巨额诈骗案。",
    tags: ["犯罪", "都市", "悬疑"],
  },
  {
    id: "t8",
    title: "北境家族",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Snowy%20northern%20manor%20at%20twilight%20with%20warm%20glowing%20windows%20and%20bare%20frozen%20trees%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-t8&orientation=landscape",
    duration: "全 26 集",
    uploadedAt: "2022-11-19",
    year: "2022",
    region: "美国",
    type: "剧情",
    playCount: 760000,
    rating: 8.5,
    uploader: "雪原影视",
    description: "一个经营百年的家族企业面临传承危机，三代人的秘密在寒冬中逐一揭开。",
    tags: ["剧情", "家族", "人性"],
  },
  {
    id: "v1",
    title: "欢乐集结号",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20bright%20comedy%20stage%20with%20confetti%20and%20a%20jubilant%20host%20silhouette%20under%20warm%20spotlights%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-v1&orientation=landscape",
    duration: "全 12 期",
    uploadedAt: "2024-09-12",
    year: "2024",
    region: "中国大陆",
    type: "喜剧",
    playCount: 1980000,
    rating: 8.8,
    uploader: "欢乐传媒",
    description: "汇集当下最受欢迎的喜剧演员，用爆笑小品与游戏环节为你带来一整季的快乐。",
    tags: ["喜剧", "搞笑", "明星"],
  },
  {
    id: "v2",
    title: "音乐现场",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20concert%20stage%20with%20haze%20and%20beams%20of%20light%20over%20a%20glowing%20microphone%20and%20a%20crowd%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-v2&orientation=landscape",
    duration: "全 10 期",
    uploadedAt: "2024-08-25",
    year: "2024",
    region: "韩国",
    type: "音乐",
    playCount: 1420000,
    rating: 9.0,
    uploader: "音浪制作",
    description: "顶级歌手现场演绎热门单曲，沉浸式舞台与乐队伴奏打造震撼的听觉盛宴。",
    tags: ["音乐", "现场", "舞台"],
  },
  {
    id: "v3",
    title: "荒野生存记",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Rugged%20wilderness%20campsite%20at%20dusk%20with%20a%20crackling%20campfire%20and%20a%20lone%20backpack%20on%20a%20rock%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-v3&orientation=landscape",
    duration: "全 14 期",
    uploadedAt: "2023-10-30",
    year: "2023",
    region: "美国",
    type: "真人秀",
    playCount: 1180000,
    rating: 8.7,
    uploader: "探索频道",
    description: "明星嘉宾被投放到无人荒野，仅凭有限工具挑战生存极限，看点十足。",
    tags: ["真人秀", "冒险", "生存"],
  },
  {
    id: "v4",
    title: "美食奇遇记",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Rustic%20open%20kitchen%20with%20steaming%20dishes%20and%20warm%20light%20and%20hands%20plating%20fresh%20colorful%20ingredients%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-v4&orientation=landscape",
    duration: "全 16 期",
    uploadedAt: "2024-07-19",
    year: "2024",
    region: "中国大陆",
    type: "美食",
    playCount: 1360000,
    rating: 8.9,
    uploader: "味觉工作室",
    description: "跟随明星寻味团走遍大江南北，寻找藏在街头巷尾的地道美味与人情故事。",
    tags: ["美食", "旅行", "人文"],
  },
  {
    id: "v5",
    title: "脱口秀之夜",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20comedy%20club%20with%20a%20single%20spotlight%20on%20a%20mic%20stand%20and%20a%20red%20brick%20wall%20background%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-v5&orientation=landscape",
    duration: "全 12 期",
    uploadedAt: "2024-06-11",
    year: "2024",
    region: "中国大陆",
    type: "脱口秀",
    playCount: 1650000,
    rating: 9.1,
    uploader: "笑果工坊",
    description: "一群年轻人用犀利的段子吐槽生活，在笑声中道出这个时代最真实的共鸣。",
    tags: ["脱口秀", "喜剧", "幽默"],
  },
  {
    id: "v6",
    title: "脑力大挑战",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20quiz%20arena%20with%20glowing%20panels%20and%20floating%20holographic%20numbers%20in%20cool%20tones%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-v6&orientation=landscape",
    duration: "全 10 期",
    uploadedAt: "2023-09-08",
    year: "2023",
    region: "日本",
    type: "竞技",
    playCount: 720000,
    rating: 8.4,
    uploader: "脑力实验室",
    description: "来自各地的脑力高手同台竞技，挑战极限推理与记忆关卡，紧张刺激又不乏幽默。",
    tags: ["竞技", "益智", "挑战"],
  },
  {
    id: "v7",
    title: "家的味道",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20home%20dining%20table%20at%20night%20with%20warm%20lanterns%20and%20a%20family%20meal%20glowing%20softly%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-v7&orientation=landscape",
    duration: "全 12 期",
    uploadedAt: "2023-08-15",
    year: "2023",
    region: "中国大陆",
    type: "生活",
    playCount: 640000,
    rating: 8.3,
    uploader: "暖屋影视",
    description: "走进普通人的家中，用一桌家常菜讲述关于亲情、乡愁与温暖的动人故事。",
    tags: ["生活", "情感", "美食"],
  },
  {
    id: "v8",
    title: "舞台之王",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20theater%20stage%20with%20red%20curtains%20and%20dramatic%20spotlight%20and%20a%20silhouetted%20performer%20in%20mid%20pose%2C%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20atmospheric%20mood%2C%20dark%20textured%20backdrop%20with%20soft%20glow%2C%20ultra%20detailed%2C%20professional%20film%20still%2C%2016:9%20widescreen%20composition&width=640&height=360&seq=v-v8&orientation=landscape",
    duration: "全 14 期",
    uploadedAt: "2024-05-24",
    year: "2024",
    region: "英国",
    type: "选秀",
    playCount: 1240000,
    rating: 8.8,
    uploader: "伦敦舞台",
    description: "素人选手登台角逐年度舞台之王，唱跳演全能比拼，梦想与汗水在这里绽放。",
    tags: ["选秀", "舞台", "音乐"],
  },
];